import { render } from "./AcceptedPapersView.vue?vue&type=template&id=4b2b4f78&scoped=true"
const script = {}

import "./AcceptedPapersView.vue?vue&type=style&index=0&id=4b2b4f78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2b4f78"]])

export default __exports__